import React ,{useState, useEffect}from 'react'
import {fetchCountries} from '../api'

function CountryPicker({handleCountryChange}) {
    
    const [countries, setCountries] = useState([]);
    useEffect(()=>{
        const fetchAPI = async()=>{
         setCountries(await fetchCountries());
        }
        fetchAPI();
    },[setCountries])
    if(countries.length  === 0){
        return "Loading countries..."
    }
    return (
        <div className="w-full px-2 my-10 sm:w-1/2 sm:mx-auto">
            <form >
                <div>
                    <select onChange={(e)=>handleCountryChange(e.target.value)} className=" w-full focus:outline-none px-4 py-2 border rounded bg-white">
                        <option value="">Choose Country (Global)</option>
                        {countries.map((country,index) => <option  value={country} key={index}>{country}</option>)}
                    </select>
                </div>
            </form>
            
        </div>
    )
}

export default CountryPicker
